__turbopack_context__.v({
  "desktopStats": "StatsSectionHomeNew-module-scss-module__4lWiUa__desktopStats",
  "divider": "StatsSectionHomeNew-module-scss-module__4lWiUa__divider",
  "label": "StatsSectionHomeNew-module-scss-module__4lWiUa__label",
  "mobileSlide": "StatsSectionHomeNew-module-scss-module__4lWiUa__mobileSlide",
  "mobileSlideContainer": "StatsSectionHomeNew-module-scss-module__4lWiUa__mobileSlideContainer",
  "mobileStatBox": "StatsSectionHomeNew-module-scss-module__4lWiUa__mobileStatBox",
  "mobileStats": "StatsSectionHomeNew-module-scss-module__4lWiUa__mobileStats",
  "number": "StatsSectionHomeNew-module-scss-module__4lWiUa__number",
  "rightCard": "StatsSectionHomeNew-module-scss-module__4lWiUa__rightCard",
  "statBox": "StatsSectionHomeNew-module-scss-module__4lWiUa__statBox",
  "statsContainer": "StatsSectionHomeNew-module-scss-module__4lWiUa__statsContainer",
  "statsWrapper": "StatsSectionHomeNew-module-scss-module__4lWiUa__statsWrapper",
});
